const homePresentation = document.querySelector('#home-presentation');
const arrow = document.querySelector('#arrow');

if (arrow) {
  arrow.addEventListener('click', () => {
    homePresentation.scrollIntoView({ behavior: 'smooth' });
  });
}

const homeCarousel = document.querySelector('.home__carrousel');

if (homeCarousel) {
  const carrouselHome = new Swiper(homeCarousel, {
    slidesPerView: 1,
    effect: 'fade',
    autoplay: {
      delay: 4000,
    },
    loop: true,
  });
}
